import ears from './ears'
import eyebrows from './eyebrows'
import eyes from './eyes'
import faceShape from './faceShape'
import facialHair from './facialHair'
import facialLines from './facialLines/facialLines'
import facialLinesEyes from './facialLines/facialLinesEyes'
import facialLinesCheek from './facialLines/facialLinesCheek'
import facialLinesChin from './facialLines/facialLinesChin'
import facialLinesForehead from './facialLines/facialLinesForehead'
import femaleShirts from './femaleShirts'
import glasses from './glasses'
import hair from './hair'
import hairBack from './hairBack'
import hats from './hats'
import jewelry from './jewelry/jewelry'
import jewelryEarrings from './jewelry/jewelryEarrings'
import jewelryNecklaces from './jewelry/jewelryNecklaces'
import maleShirts from './maleShirts'
import mouth from './mouths'
import nose from './noses'
import eyeShadow from './eyeShadow'

const shirt = [...maleShirts, ...femaleShirts]

const data = {
  ears,
  eyeShadow,
  eyebrows,
  eyes,
  faceShape,
  facialHair,
  facialLines,
  facialLinesEyes,
  facialLinesCheek,
  facialLinesChin,
  facialLinesForehead,
  femaleShirts,
  glasses,
  hair,
  hairBack,
  hats,
  jewelry,
  jewelryEarrings,
  jewelryNecklaces,
  maleShirts,
  mouth,
  nose,
  shirt,
}

export default data
